import * as angular from 'angular';

import { IRequestService } from '../../services';
import { IStoreActionsService } from '../storeActions.service';

export interface SSOResponse {
    login: string;
    sessionId: string;
}

export interface ISingleSignOnService {
    login(): angular.IPromise<any>;
}

export class SingleSignOnService implements ISingleSignOnService {
    static serviceId = 'singleSignOnService';
    static $inject = ['$http', 'requestService', 'storeActionsService'];


    constructor(
        private _$http,
        private _requestService: IRequestService,
        private _storeActionsService: IStoreActionsService
    ) {
    }

    login(): angular.IPromise<any> {
        const request: angular.IRequestConfig = {
            method: 'GET',
            url: this._requestService.getUrlV1() + 'SingleSignOn'
        };

        return this._$http(request, { withCredentials: true })
            .then(response => this.doLogin(response.data));
    }

    private doLogin(data: SSOResponse): angular.IPromise<any> {
        return this._storeActionsService.authentication
            .login({ userName: data.login, password: undefined, session: data.sessionId });
    }
}